<template>
    <div class="user_sattings">
      <!--用户设置头部-->
      <div class="user_settings_top">
        <div><input type="text" v-model.trim="loginName" title="登录账号" placeholder="登录账号"></div>
        <div><input type="text" v-model.trim="name" title="姓名" placeholder="姓名"></div>
        <div>
          <el-select v-model.trim="selectRole" placeholder="请选择">
            <el-option
              v-for="item in allRoles"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id">
            </el-option>
          </el-select>
        </div>
        <div class="w172">
          <input type="checkbox" v-model="showNotLogin" id="notLoginUser" title="无法正常登录的用户">
          <label for="notLoginUser">显示无法正常登录的用户</label>
        </div>
        <button class="btn_normal w116" @click="queryData()">查询</button>
        <button class="btn_normal w116" @click="ctrlBtn('addUser', null)">新增用户</button>
        <button class="btn_normal w116" @click="ctrlBtn('QQNum', null)">设置客服QQ</button>
      </div>

      <!--用户设置信息-->
      <div class="user_settings_msg">
        <!--表格-->
        <table class="table">
          <thead>
          <tr>
            <th>登录账号</th>
            <th>角色</th>
            <th>姓名</th>
            <th>联系电话</th>
            <th>？启用</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody v-if="userList.length">
          <tr v-for="(item, index) in userList" :key="index">
            <td>{{item.LoginName}}</td>
            <td>{{item.RoleName}}</td>
            <td>{{item.UserName}}</td>
            <td>{{item.Tel}}</td>
            <td>{{item.Status | status}}</td>
            <td>
              <div>
                <a class="fcLinkA" title="重置密码" @click="ctrlBtn('resetPwd', item)">重置密码</a>
                <a class="fcLinkA" title="编辑" @click="ctrlBtn('modifyUser', item)">编辑</a>
                <a class="fcLinkA" v-if="item.Status === 2" title="启用" @click="ctrlBtn('enableUser', item)">启用</a>
                <a class="fcLinkA" v-if="item.Status === 2" title="删除" @click="ctrlBtn('delUser', item)">删除</a>
                <a class="fcLinkA" v-if="item.Status === 1 && (loginUserId !== item.Id)" title="停用" @click="ctrlBtn('disableUser', item)">停用</a>
              </div>
            </td>
          </tr>
          </tbody>
          <tbody v-if="!userList.length">
          <tr>
            <td colspan="6">暂时没有相关的数据</td>
          </tr>
          </tbody>
        </table>

        <!--分页-->
        <div class="text_right mt20">
          <el-pagination
            background
            :prev-text="'上一页'"
            :next-text="'下一页'"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>

      <!--弹出框-->
      <user-settings-embed-msg v-if="isShow" :title="dialogTitle"
                               :userMsg="userMsg"
                               :showType="dialogShowType"
                               @cancelbtn="getSelectDialogEmbed"></user-settings-embed-msg>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :txt="txtMsg"
                  :is-suc="isSuc"
                  @closebtn="closeMsgDialog"></msg-dialog>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>
    </div>
</template>

<script type="es6">
  // import SelectDialogEmbed from '../../public-component/select-dialog-embed';
  import UserSettingsEmbedMsg from './user-settings-embed-msg';
  import MsgDialog from '../../public-component/msg-dialog';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'user-settings',
    // components: {SelectDialogEmbed, LoadingDialog},
    components: {UserSettingsEmbedMsg, MsgDialog, LoadingDialog},
    data() {
      return {
        userList: [], // 用户列表
        loginName: '', // 登录账号
        loginUserId: sessionStorage.getItem('userId'),
        name: '', // 姓名
        showNotLogin: false, // 显示无法正常登陆的用户
        userMsg: null, // 用户信息
        allRoles: [], // 所有角色
        selectRole: '', // 选择的角色
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载框类型
        isShow: false, // 提示框显示
        dialogTitle: null, // 弹出框头部名
        dialogShowType: null, // 弹出框类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '', // 信息框内容
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前显示几条数据
        total: 0 // 总条数
      }
    },
    methods: {
      // 获取当前分销商的所有角色——下拉框的
      getClientRoleData() {
        this.$axios.get(this.Global.getClientRoleData).then((res) => {
          if (!res.data.errorMsg.length) {
            for (let i = 0; i < res.data.resData.length; i++) {
              this.allRoles.push({Id: res.data.resData[i].Id, Name: res.data.resData[i].Name});
            }
            this.allRoles.splice(0, 0, {Name: '所有角色', Id: ''});
            this.selectRole = '';
          } else {
            this.allRoles = [];
            this.selectRole = res.data.errorMsg;
          }
        });
      },

      // 根据登陆账号 + 姓名 + 角色 + 是否无法正常登录的用户 查询用户分页数据
      queryData() {
        this.currentPage = 1;
        this.getUseList();
      },

      // 获取用户分页数据
      getUseList() {
        this.isLoading = true;
        const params = {
          loginName: this.loginName,
          Name: this.name,
          RoleId: this.selectRole,
          ShowNotLogin: this.showNotLogin,
          pageIndex: this.currentPage,
          pageSize: this.pageSize
        };
        this.$axios.post(this.Global.getUseList, params).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.userList = res.data.resData.DataList;
                self.total = res.data.resData.TotalCounts;
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
                self.userList = [];
                self.total = 0;
              }
            }
          }, 500);
        }, err => {
          this.isLoading = false;
          console.log(err);
        });
      },

      // 操作按钮
      ctrlBtn(type, userMsg) {
        this.isShow = true;
        this.dialogShowType = type;
        switch (type) {
          case 'QQNum':
            this.dialogTitle = '客服QQ设置';
            break;
          case 'addUser':
            this.dialogTitle = '新增用户';
            break;
          case 'modifyUser':
            this.dialogTitle = '编辑用户';
            break;
          default:
              this.dialogTitle = '提示';
              break;
        }
        this.userMsg = userMsg;
      },

      // 接收弹出框传送的数据
      getSelectDialogEmbed(e) {
        this.isShow = e.isShow;
        if (e.handleType) {
          this.getUseList();
        }
      },

      // 分页——当前页面显示条数改变
      handleSizeChange(val) {
        this.pageSize = val;
        // 当前页面显示条数改变重新获取用户分页数据
        this.getUseList();
      },

      // 分页——当前页改变
      handleCurrentChange(val) {
        this.currentPage = val;
        // 当前页改变重新获取用户分页数据
        this.getUseList();
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      }
    },
    created() {
      this.getClientRoleData();
      this.getUseList();
    },
    activated() { // 只有keep-alive激活才会被使用
      if (sessionStorage.getItem('isRefresh') === 'true') { // 从左边的菜单进去刷新页面
        sessionStorage.setItem('isRefresh', 'false');
        this.userList = [];
        this.loginName = '';
        this.name = '';
        this.selectRole = '';
        this.showNotLogin = false;
        this.isShow = false;
        this.currentPage = 1;
        this.pageSize = 10;
        this.total = 0;
        this.getUseList();
      }
    },
    beforeRouteLeave(to, from, next) {
      to.meta.keepAlive = true;
      next();
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/style";
  @import "../../../assets/css/base-color";
  @import "../../../assets/css/home-view";

  .user_sattings {
    .user_settings_top {
      & > div {
        width: 12%;
      }
    }
    .btn_normal {
      padding: 7px 10px;
    }
  }

  .table {
    td {
      div {
        display: inline-block;
        width: 182px;
        margin: auto;
        text-align: left;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/system-based/user-settings.vue